import sectionImage from "../../../assets/homePageV2/web-app.png";
import { operacaoNaPalmaDaMaoContent as c } from "./content";
import { ReactComponent as BackIcon } from "../../../assets/svg/icons/back.svg";

export function Features() {
  return (
    <section className="home-page-v2__section home-page-v2__section--palma">
      <div className="home-page-v2__section-inner home-page-v2__palma-layout">
        <div className="home-page-v2__palma-copy">
          <h2 id="operacao-palma-heading">{c.heading}</h2>
          <p>{c.body}</p>
        </div>
        <div className="home-page-v2__palma-features">
          <ul className="pill-list pill-list--compact">
            {c.features.map((text) => (
              <li key={text}>
                <div className="home-page-v2__pill-list-icon" aria-hidden>
                  <BackIcon width={20} height={20} />
                </div>
                <span>
                  {text}
                </span>
              </li>
            ))}
          </ul>
        </div>
      </div>
      <div className="home-page-v2__palma-image-wrapper">
        <div className="home-page-v2__palma-image">
          <img src={sectionImage} alt="A operação na palma da mão" width={1200} height={675} />
        </div>
      </div>
    </section>
  );
}
